import React from "react";
import { IntlShape } from "react-intl";
import { ITheme, builtinFormatters } from "cayo.ui";
import { ExecutionRecord, JobRecord } from "@cayo/shared/api/types/cayo-graph";
import { buildInIconFormatters } from "@cayo/shared/scheme/formatters/buildInIconFormatters";
import { IAppTheme } from "@cayo/shared/themes/types";
import {
  ActionContainer,
  DurationWrapper,
  StyledWorkflowTitle,
  WorkflowItemContainer,
} from "./tree.styles";
import Icon from "../Graphics/Icon";
import { AuxRenderProps } from "../LegacyDetailsList/cell-renderers";

const jobIcon = (item: ExecutionRecord, theme: ITheme) => {
  const value = item["executionState"] as string;

  const icon = buildInIconFormatters.jobstate(theme as IAppTheme, {
    executionState: item.executionState || "none",
    lastExecutionResult: item.executionResult || "none",
  });

  return (
    <Icon
      rotate={value === "running" ? "1" : ""}
      iconName={icon?.iconName || "UnknownSolid"}
      // eslint-disable-next-line no-inline-styles/no-inline-styles
      style={{ fontSize: "14px", color: icon?.color || theme.cayoTheme.brandColors.disabled }}
    />
  );
};

const workFlowItem = (item: any, index: number, isSelected: boolean, auxProps?: AuxRenderProps) => {
  const jobRecord = item as JobRecord;
  const title = jobRecord.name || jobRecord.objectName;
  return (
    <WorkflowItemContainer key={item.id}>
      {treeRendereres.jobIcon(jobRecord, auxProps!.theme)}
      <ActionContainer horizontalAlign="stretch" verticalAlign="center" horizontal grow={1}>
        <StyledWorkflowTitle isSelected={isSelected} title={title}>
          {title}
        </StyledWorkflowTitle>
        {duration(item?.duration, auxProps!.intl)}
      </ActionContainer>
    </WorkflowItemContainer>
  );
};

function duration(duration?: string, intl?: IntlShape) {
  return <DurationWrapper>{builtinFormatters.duration(duration, intl)}</DurationWrapper>;
}
const treeRendereres = {
  workFlowItem,
  jobIcon,
  duration,
};

export default treeRendereres;
